import moment from 'moment';

require('moment/locale/pt-br')
require('moment/locale/es')

export default function install (Vue) {
  Object.defineProperties(Vue.prototype, {
    $moment: {
      get () {
        return moment;
      }
    }
  })
}